import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div id="revisions" data-post-id={{@model.post_id}} class={{@hiddenClasses}}>
  {{#if @model.title_changes}}
    <div class="row">
      <h2 class="revision__title">{{html-safe @titleDiff}}</h2>
    </div>
  {{/if}}
  {{#if @mobileView}}
    {{#if @userChanges}}
      <div class="row">
        {{bound-avatar-template
          @model.user_changes.previous.avatar_template
          "small"
        }}
        {{@model.user_changes.previous.username}}
        &rarr;
        {{bound-avatar-template
          @model.user_changes.current.avatar_template
          "small"
        }}
        {{@model.user_changes.current.username}}
      </div>
    {{/if}}
    {{#if @model.wiki_changes}}
      <div class="row">
        {{d-icon
          "far-edit"
          class=(if @model.wiki_changes.current "diff-ins" "diff-del")
        }}
      </div>
    {{/if}}
    {{#if @model.archetype_changes}}
      <div class="row">
        {{d-icon
          (if
            (eq @model.archetype_changes.current "private_message")
            "envelope"
            "comment"
          )
        }}
      </div>
    {{/if}}
    {{#if (and @model.category_id_changes (not @model.archetype_changes))}}
      <div class="row">
        {{#if @previousCategory}}
          {{html-safe @previousCategory}}
        {{else}}
          {{d-icon "far-eye-slash" class="diff-del"}}
        {{/if}}
        &rarr;
        {{#if @currentCategory}}
          {{html-safe @currentCategory}}
        {{else}}
          {{d-icon "far-eye-slash" class="diff-ins"}}
        {{/if}}
      </div>
    {{/if}}
  {{/if}}
  {{#if @model.tags_changes}}
    <div class="row -tag-revisions">
      <span class="discourse-tags">
        {{#each @previousTagChanges as |t|}}
          {{discourse-tag t.name extraClass=(if t.deleted "diff-del")}}
        {{/each}}
      </span>
      {{#if (or @mobileView (eq @viewMode "inline"))}}
        &rarr;&nbsp;
      {{/if}}
      <span class="discourse-tags">
        {{#each @currentTagChanges as |t|}}
          {{discourse-tag t.name extraClass=(if t.inserted "diff-ins")}}
        {{/each}}
      </span>
    </div>
  {{/if}}
  {{#if @model.featured_link_changes}}
    <div class="row">
      {{@model.featured_link_changes.previous}}
      &rarr;
      {{@model.featured_link_changes.current}}
    </div>
  {{/if}}

  <span>
    <PluginOutlet
      @name="post-revisions"
      @connectorTagName="div"
      @outletArgs={{hash model=@model}}
    />
  </span>

  <LinksRedirect
    {{did-insert @calculateBodyDiff @bodyDiffHTML}}
    {{did-update @calculateBodyDiff @bodyDiffHTML}}
    class="row body-diff"
  >
    {{html-safe @bodyDiff}}
  </LinksRedirect>
</div>
*/
{
  "id": "y1kS4DoX",
  "block": "[[[10,0],[14,1,\"revisions\"],[15,\"data-post-id\",[30,1,[\"post_id\"]]],[15,0,[30,2]],[12],[1,\"\\n\"],[41,[30,1,[\"title_changes\"]],[[[1,\"    \"],[10,0],[14,0,\"row\"],[12],[1,\"\\n      \"],[10,\"h2\"],[14,0,\"revision__title\"],[12],[1,[28,[35,1],[[30,3]],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[41,[30,4],[[[41,[30,5],[[[1,\"      \"],[10,0],[14,0,\"row\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[[30,1,[\"user_changes\",\"previous\",\"avatar_template\"]],\"small\"],null]],[1,\"\\n        \"],[1,[30,1,[\"user_changes\",\"previous\",\"username\"]]],[1,\"\\n        →\\n        \"],[1,[28,[35,2],[[30,1,[\"user_changes\",\"current\",\"avatar_template\"]],\"small\"],null]],[1,\"\\n        \"],[1,[30,1,[\"user_changes\",\"current\",\"username\"]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,1,[\"wiki_changes\"]],[[[1,\"      \"],[10,0],[14,0,\"row\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"far-edit\"],[[\"class\"],[[52,[30,1,[\"wiki_changes\",\"current\"]],\"diff-ins\",\"diff-del\"]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,1,[\"archetype_changes\"]],[[[1,\"      \"],[10,0],[14,0,\"row\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[[52,[28,[37,4],[[30,1,[\"archetype_changes\",\"current\"]],\"private_message\"],null],\"envelope\",\"comment\"]],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[28,[37,5],[[30,1,[\"category_id_changes\"]],[28,[37,6],[[30,1,[\"archetype_changes\"]]],null]],null],[[[1,\"      \"],[10,0],[14,0,\"row\"],[12],[1,\"\\n\"],[41,[30,6],[[[1,\"          \"],[1,[28,[35,1],[[30,6]],null]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,3],[\"far-eye-slash\"],[[\"class\"],[\"diff-del\"]]]],[1,\"\\n\"]],[]]],[1,\"        →\\n\"],[41,[30,7],[[[1,\"          \"],[1,[28,[35,1],[[30,7]],null]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,3],[\"far-eye-slash\"],[[\"class\"],[\"diff-ins\"]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[41,[30,1,[\"tags_changes\"]],[[[1,\"    \"],[10,0],[14,0,\"row -tag-revisions\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"discourse-tags\"],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,8]],null]],null],null,[[[1,\"          \"],[1,[28,[35,9],[[30,9,[\"name\"]]],[[\"extraClass\"],[[52,[30,9,[\"deleted\"]],\"diff-del\"]]]]],[1,\"\\n\"]],[9]],null],[1,\"      \"],[13],[1,\"\\n\"],[41,[28,[37,10],[[30,4],[28,[37,4],[[30,10],\"inline\"],null]],null],[[[1,\"        → \\n\"]],[]],null],[1,\"      \"],[10,1],[14,0,\"discourse-tags\"],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,11]],null]],null],null,[[[1,\"          \"],[1,[28,[35,9],[[30,12,[\"name\"]]],[[\"extraClass\"],[[52,[30,12,[\"inserted\"]],\"diff-ins\"]]]]],[1,\"\\n\"]],[12]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[41,[30,1,[\"featured_link_changes\"]],[[[1,\"    \"],[10,0],[14,0,\"row\"],[12],[1,\"\\n      \"],[1,[30,1,[\"featured_link_changes\",\"previous\"]]],[1,\"\\n      →\\n      \"],[1,[30,1,[\"featured_link_changes\",\"current\"]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[10,1],[12],[1,\"\\n    \"],[8,[39,11],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"post-revisions\",\"div\",[28,[37,12],null,[[\"model\"],[[30,1]]]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[8,[39,13],[[24,0,\"row body-diff\"],[4,[38,14],[[30,13],[30,14]],null],[4,[38,15],[[30,13],[30,14]],null]],null,[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,1],[[30,15]],null]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[13]],[\"@model\",\"@hiddenClasses\",\"@titleDiff\",\"@mobileView\",\"@userChanges\",\"@previousCategory\",\"@currentCategory\",\"@previousTagChanges\",\"t\",\"@viewMode\",\"@currentTagChanges\",\"t\",\"@calculateBodyDiff\",\"@bodyDiffHTML\",\"@bodyDiff\"],false,[\"if\",\"html-safe\",\"bound-avatar-template\",\"d-icon\",\"eq\",\"and\",\"not\",\"each\",\"-track-array\",\"discourse-tag\",\"or\",\"plugin-outlet\",\"hash\",\"links-redirect\",\"did-insert\",\"did-update\"]]",
  "moduleName": "discourse/components/modal/history/revisions.hbs",
  "isStrictMode": false
});